import style from '../styles/Prodotti.module.css'
import {Trans, useTranslation} from "react-i18next";

export default function Prodotti() {
    const { t, i18n } = useTranslation();

    const buttonStyle = {
        display: 'inline-block',
        padding: '12px 28px',
        backgroundColor: '#dbd5a6',
        color: '#13220e',
        textDecoration: 'none',
        borderRadius: '50px',
        fontSize: '16px',
        fontWeight: 'bold',
        transition: 'all 0.3s ease',
        marginTop: '20px',
        cursor: 'pointer',
        border: 'none',
    };

    return (
        <div className={style.mainContainer}>
            <div className={style.contentContainer}>
                <p className={style.title}><Trans i18nKey="vini.titolo" components={{br: <br/>}}/></p>
                
                <div className={style.productContainer}>
                    <div className={style.productContentContainer}>
                        <p className={style.productTitle}>
                            ZENA <br/>
                            <span style={{fontWeight: 'normal'}}>
                               Trebbiano Marche <br/>
                                <Trans i18nKey="vini.indicazione-vino-1" components={{br: <br/>}}/> <br/>
                            </span>
                        </p>
                        <p className={style.productDescription}>
                            <Trans i18nKey="vini.descrizione-vino-1" components={{br: <br/>, em: <em/>}}/>
                        </p>
                        <a 
                            href="https://sciauerta.bigcartel.com/product/zena-trebbiano-marche-igt"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={buttonStyle}
                        >
                            Acquista →
                        </a>
                    </div>
                    <img src={'/images/prodotti/zena-fronte.png'} alt={'bottiglia img'}
                         className={style.productImage}/>
                </div>

                <div className={style.productContainer}>
                    <div className={style.productContentContainer}>
                        <p className={style.productTitle}>
                            RSTP <br/>
                            <span style={{fontWeight: 'normal'}}>
                               Sangiovese Marche<br/>
                                <Trans i18nKey="vini.indicazione-vino-1" components={{br: <br/>}}/> <br/>
                            </span>
                        </p>
                        <p className={style.productDescription}>
                            <Trans i18nKey="vini.descrizione-vino-rstp" components={{br: <br/>, em: <em/>}}/>
                        </p>
                        <a 
                            href="https://sciauerta.bigcartel.com/product/rstp"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={buttonStyle}
                        >
                            Acquista →
                        </a>
                    </div>
                    <img src={'/images/prodotti/rstp-fronte.png'} alt={'bottiglia img'}
                         className={style.productImage}/>
                </div>

                <div className={style.productContainer}>
                    <div className={style.productContentContainer}>
                        <p className={style.productTitle}>
                            VIPERINA <br/>
                            <span style={{fontWeight: 'normal'}}>
                               Marche Bianco <br/>
                                <Trans i18nKey="vini.indicazione-vino-1" components={{br: <br/>}}/> <br/>
                            </span>
                        </p>
                        <p className={style.productDescription}>
                            <Trans i18nKey="vini.descrizione-vino-viperina" components={{br: <br/>, em: <em/>}}/>
                        </p>
                        <a 
                            href="https://sciauerta.bigcartel.com/product/viperina"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={buttonStyle}
                        >
                            Acquista →
                        </a>
                    </div>
                    <img src={'/images/prodotti/viperina-fronte.png'} alt={'bottiglia img'}
                         className={style.productImage}/>
                </div>
            </div>
        </div>
    )
}